// Badge.styles.tsx
import styled from "@emotion/styled";
import { BadgeProps } from "./Badge.types";
import { generateBadgeStyles } from "./utils";

export const BadgeWrapper = styled.span<BadgeProps>`
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  line-height: 13px;
  letter-spacing: 2px;
  text-transform: uppercase;
  ${(props) => generateBadgeStyles(props)}
`;
